(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const init = () => {
      const drawer = document.querySelector('cart-drawer');
      const dialog = drawer?.querySelector('dialog');
      if (!dialog) return;
      new MutationObserver(() => {
        if (!dialog.open) return;
        const header = document.querySelector('.site-header');
        const desktop = window.matchMedia('(min-width: 1024px)').matches;
        const top = desktop && header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
        drawer.style.setProperty('--cart-drawer-top', top + 'px');
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('l2-locations')) {
    customElements.define('l2-locations', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-locations-track]');
        const dotsWrap = this.querySelector('.locations__dots');
        if (!track || !dotsWrap) return;
        const dots = [...dotsWrap.children];
        const update = () => {
          const overflowing = track.scrollWidth - track.clientWidth > 2;
          dotsWrap.hidden = !overflowing;
          const cards = [...track.children];
          let active = 0;
          cards.forEach((card, i) => { if (card.offsetLeft - track.offsetLeft - track.scrollLeft <= card.offsetWidth / 2) active = i; });
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) active = cards.length - 1;
          dots.forEach((dot, i) => dot.setAttribute('aria-current', i === active ? 'true' : 'false'));
        };
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
